// extracted by mini-css-extract-plugin
export var cardTitle = "_ch-1";
export var commentBubble = "_ch-e";
export var commentForm = "_ch-a";
export var commentInput = "_ch-b";
export var commentLabel = "_ch-d";
export var commentPrompt = "_ch-9";
export var csatCard = "_ch-0";
export var feedbackSection = "_ch-7";
export var starDisabled = "_ch-6";
export var starEmpty = "_ch-5";
export var starFilled = "_ch-4";
export var starWrapper = "_ch-3";
export var starsContainer = "_ch-2";
export var submittedComment = "_ch-c";
export var thankYouText = "_ch-8";